import { Injectable } from '@angular/core';
import { CompanyEmployeeWithSubsidyAmount } from '@app/@graphql';
import { MenuItemData } from '@app/pages/menu';
import { Observable, of } from 'rxjs';
import { MenuEntriesData, MenuEntry, MenuEntrySummary } from '../data/restaurant-data';
import moment from 'moment';
import { isArray } from 'util';
//import { start } from 'repl';

@Injectable()
export class MenuEtriesService extends MenuEntriesData
{
    private allEntries: MenuEntrySummary[] = [
        {
            id: 1,
            placedOrdersCount: 100,
            completedOrdersCount: 99,
            totalValue: 990,
            dishOfTheDay: new Date(),
            price: 15,
            details: [{
                title: 'Potrawa 2',
                description: 'Zapiekanka ziemniaczana',
                languageId: 1,
                language: 'pl',
                imageUrl: 'https://pysznosci.pl/wp-content/uploads/2020/08/miniatu-zap--495x260.jpg.webp',
                ingredients: ['Ziemniaki'],
                parts: ['Ziemniaki']
            }],
            categories: [{
                id: 1,
                languageId: 1,
                language: 'pl',
                name: 'Mięsna'
            }],
            allergens: [{
                id: 1,
                languageId: 1,
                language: 'pl',
                name: 'Orzechy'
            }],
            isHidden: false
        },
        {
            id: 2,
            placedOrdersCount: 30,
            completedOrdersCount: 30,
            totalValue: 450,
            dishOfTheDay: new Date(),
            price: 25,
            details: [{
                title: 'Potrawa 1',
                description: 'Wolnogotowana wołowina',
                languageId: 1,
                language: 'pl',
                imageUrl: 'https://zmwarmia.pl/wp-content/uploads/2018/04/Wo%C5%82owina-wolno-gotowana-ZM-Warmia_1-784x534.jpg',
                ingredients: ['Wołowina'],
                parts: ['Wołowina']
            }],
            categories: [{
                id: 2,
                languageId: 2,
                language: 'pl',
                name: 'Wegańska'
            }],
            allergens: [{
                id: 2,
                languageId: 1,
                language: 'pl',
                name: 'Ziemniaki'
            }],
            isHidden: false
        },
        {
            id: 3,
            placedOrdersCount: 0,
            completedOrdersCount: 0,
            totalValue: 0,
            dishOfTheDay: new Date(),
            price: 20,
            details: [{
                title: 'Potrawa 1',
                description: 'Wolnogotowana wołowina',
                languageId: 1,
                language: 'pl',
                imageUrl: 'https://zmwarmia.pl/wp-content/uploads/2018/04/Wo%C5%82owina-wolno-gotowana-ZM-Warmia_1-784x534.jpg',
                ingredients: ['Wołowina'],
                parts: ['Wołowina']
            }],
            categories: [{
                id: 1,
                languageId: 1,
                language: 'pl',
                name: 'Mięsna'
            }],
            allergens: [{
                id: 1,
                languageId: 1,
                language: 'pl',
                name: 'Orzechy'
            }],
            isHidden: false
        }
    ]

    private menuEntries = 
    [
        {
            entries: this.allEntries,
            menuStartDate: moment().startOf('week').toDate(),
            menuEndDate: moment().endOf('week').toDate(),
        },
        {
            entries: this.allEntries,
            menuStartDate: moment().add(7, 'days').startOf('week').toDate(),
            menuEndDate: moment().add(7, 'days').endOf('week').toDate(),
        }
    ];

    getMenuEntryForDate(startDay: Date): Observable<MenuEntry> {
        let ret = this.menuEntries.find(a => moment(a.menuStartDate) <= moment(startDay) && moment(a.menuEndDate) >= moment(startDay) );

        if (!ret) {
            ret = {
                entries: [],
                menuStartDate: startDay,
                menuEndDate: startDay
            };
        }

        return of(ret);
    }
}